import { UserManager, WebStorageStateStore } from 'oidc-client-ts'

/**
 * Cognito Hosted UI(Managed Login) を使った Authorization Code Flow (PKCE) の設定。
 * ログイン画面はCognito側にリダイレクトする方式のため、このアプリ自体には
 * ログインフォームを作らない。未認証時は stores/auth.ts の initialize() が
 * 自動的に signinRedirect() を呼び、ボタン操作を待たずログイン画面へ遷移する。
 *
 * 必要な環境変数は .env.example を参照 (common/Judge-Cognito スタックの出力値から埋める)。
 */
export const userManager = new UserManager({
  authority: import.meta.env.VITE_COGNITO_AUTHORITY,
  client_id: import.meta.env.VITE_COGNITO_CLIENT_ID,
  redirect_uri: import.meta.env.VITE_COGNITO_REDIRECT_URI,
  post_logout_redirect_uri: import.meta.env.VITE_COGNITO_LOGOUT_URI,
  response_type: 'code',
  scope: 'openid email profile',
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: true,
  // Cognito UserPool は標準のOIDC discovery(/.well-known/openid-configuration)に対応している
  loadUserInfo: true,
})

/** Cognito Hosted UIのログアウトエンドポイントへ遷移する(標準OIDCのend_session_endpointが
 *  Cognitoでは若干仕様が異なるため、Hosted UIの/logoutを直接組み立てる) */
export function buildCognitoLogoutUrl(): string {
  const domain = import.meta.env.VITE_COGNITO_HOSTED_UI_DOMAIN
  const clientId = import.meta.env.VITE_COGNITO_CLIENT_ID
  const logoutUri = encodeURIComponent(import.meta.env.VITE_COGNITO_LOGOUT_URI)
  return `${domain}/logout?client_id=${clientId}&logout_uri=${logoutUri}`
}
